import { fetchJson } from "@/services/api-client";
import { fileToBase64 } from "@/utils/file-upload";

export async function getUploadUrl(
  key: string,
  memberMeta?: {
    orgId: string;
    userId: string;
    token?: string;
  },
): Promise<string> {
  const url = memberMeta
    ? `/api/upload?key=${key}&orgId=${memberMeta.orgId}&userId=${memberMeta.userId}&token=${memberMeta.token}`
    : `/api/upload?key=${key}`;

  const data = await fetchJson<{ url: string }>(
    url,
    { method: "GET" },
    { fallbackErrorMessage: "Failed to get signed upload Url" },
  );

  return data.url;
}
/**
 * Uploads a file to the S3 and returns the URL
 * @param organizationId The organization ID
 * @param key The key to store the file under
 * @param file the file to upload
 */
export async function uploadFile(
  organizationId: string,
  key: string,
  file: File,
) {
  let base64: string;

  if (file.type === "application/pdf") {
    // For PDFs, read as ArrayBuffer and convert to base64
    const arrayBuffer = await file.arrayBuffer();
    base64 = Buffer.from(arrayBuffer).toString("base64");
  } else {
    // For images, use the existing fileToBase64 function
    base64 = await fileToBase64(file);
  }

  await fetchJson<unknown>(
    "/api/upload",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        organizationId,
        base64Image: base64,
        key,
        fileName: file.name,
        contentType: file.type,
      }),
    },
    { fallbackErrorMessage: "Failed to upload file" },
  );
}
